import type { StepType } from "@reactour/tour";

export const datosAnioTourSteps: StepType[] = [
	{
		selector: "[data-tour-id='title']",
		content:
			"Esta es la pantalla de datos anuales. Permite guardar y consultar cifras importantes de cada año.",
	},
	{
		selector: "[data-tour-id='header-trabajadores']",
		content: "El número de trabajadores en la empresa ese año.",
	},
	{
		selector: "[data-tour-id='header-materia-prima']",
		content: "Los kilogramos de materia prima usados en la empresa ese año.",
	},
	{
		selector: "[data-tour-id='header-desechos']",
		content: "El número de desechos generados en la empresa ese año.",
	},
	{
		selector: "[data-tour-id='header-facturacion']",
		content: "El valor de la facturación en la empresa ese año.",
	},
	{
		selector: "[data-tour-id='submit-button']",
		content: "El botón de guardar salva los cambios realizados en los datos.",
	},
];
